<template>
  <div class="main-wrapper">
    <div class="container mt-5 bg-white py-4">
      <h1 class="text-dark text-center py-3">{{ $t(title) }}</h1>
      <div id="accordion">
        <div v-for="(item, index) in $t(questions)" :key="index" class="card">
          <div
            class="card-header py-4 px-2 bg-white"
            :id="'heading' + index"
            data-toggle="collapse"
            :data-target="'#collapse' + index"
            aria-expanded="true"
            :aria-controls="'collapse' + index"
            @click="toggleAccordion(index)"
          >
            <h5 class="mb-0 text-dark">
              <i
                class="fas mr-2 text-gray"
                :class="{
                  'rotate-90': isOpen === index,
                  'fa-chevron-right plus': ['en'].includes(locale),
                  'fa-chevron-left ninus': ['ar', 'ur'].includes(locale),
                }"
              ></i>
              {{ item.question }}
            </h5>
          </div>
          <div
            :id="'collapse' + index"
            class="collapse"
            :aria-labelledby="'heading' + index"
            data-parent="#accordion"
          >
            <div class="card-body">
              <template v-if="Array.isArray(item.answer)">
                <div
                  v-for="(subAnswer, subIndex) in item.answer"
                  :key="subIndex"
                >
                  <div v-if="subAnswer.startsWith('link#')">
                    <a :href="subAnswer.split('#')[3]" target="_blank">
                      {{ subAnswer.split("#")[1] }}
                      <span> {{ subAnswer.split("#")[2] }}</span>
                    </a>
                  </div>
                  <div v-else-if="subAnswer.startsWith('itemlink#')">
                    <div class="d-flex align-items-center mt-2">
                      <p class="d-flex align-items-center mr-1 mb-0">
                        <span class="bullet"></span>
                        {{ subAnswer.split("#")[1] }}
                      </p>
                      <a :href="subAnswer.split('#')[3]" target="_blank">
                        <span> {{ subAnswer.split("#")[2] }}</span>
                      </a>
                    </div>
                  </div>
                  <div v-else-if="subAnswer.startsWith('title#')">
                    <p class="my-2 text-dark font-weight-bold">
                      {{ subAnswer.split("#")[1] }}
                    </p>
                  </div>
                  <div v-else-if="subAnswer.startsWith('item#')">
                    <p class="my-2 d-flex align-items-center">
                      <span class="bullet"></span>
                      {{ subAnswer.split("#")[1] }}
                    </p>
                  </div>
                  <div v-else-if="subAnswer.startsWith('video#')">
                    <iframe
                      width="560"
                      height="315"
                      :src="getVideoURL(subAnswer)"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                  </div>
                  <div v-else>
                    {{ subAnswer }}
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-if="item.answer.startsWith('string')">
                  {{ item.answer }}
                </div>
                <div v-else-if="item.answer.startsWith('video#')">
                  <iframe
                    width="560"
                    height="315"
                    :src="getVideoURL(item.answer)"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>
                <div v-else>
                  {{ item.answer }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const CRUD_CODE = "faq";
export default {
  name: "component",
  data() {
    return {
      routePrefix: CRUD_CODE,
      transPrefix: CRUD_CODE,
      header: "faq.header",
      title: "faq.title",
      questions: "faq.questions",
      locale: this.$route.params.locale,
      isOpen: null,
      isRTL: null,
    };
  },
  created() {
    const locale = this.$route.params.locale;
    console.log("Locale:", locale);
    // Now you have the locale from the URL parameters
  },
  methods: {
    toggleAccordion(index) {
      this.isOpen = this.isOpen === index ? null : index; // Toggle the state of the accordion
    },
    getVideoURL(data) {
      return data.split("#")[1];
    },
    getLinkURL(data) {
      return data.split("#")[1];
    },
  },
};
</script>

<style>
.main-wrapper {
  background: white !important;
  width: 100%;
  margin: -48px 0 0 0;
  padding: 0;
}
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
.card {
  border: none !important;
  border-radius: 0 !important;
}
.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: none !important;
}
.text-gray {
  color: #6c757d;
}
.rotate-90.plus {
  transform: rotate(90deg);
}

.rotate-90.ninus {
  transform: rotate(-90deg);
}

.bullet {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-inline: 8px;
  background: #999;
}
.rtl-flip {
  transform: scaleX(-1);
}
</style>
